import { type AxiosError, isAxiosError } from 'axios'

import {
  DynatracePreFlightErrorResponseStatus,
  type DynatracePreFlightErrorResponse
} from 'queries/status-checks/pre-flight/types'

export function isPreFlightErrorResponse(
  response: unknown
): response is DynatracePreFlightErrorResponse {
  const responseStatuses: string[] = Object.values(
    DynatracePreFlightErrorResponseStatus
  )

  return (
    response !== null &&
    typeof response === 'object' &&
    'status' in response &&
    typeof response.status === 'string' &&
    responseStatuses.includes(response.status)
  )
}

export function isPreFlightEntityNotFoundError(
  error: AxiosError<DynatracePreFlightErrorResponse> | Error
) {
  return (
    isAxiosError(error) &&
    error.response?.data.status ===
      DynatracePreFlightErrorResponseStatus.DYNATRACE_NOT_FOUND
  )
}
